export default "__VITE_ASSET__BIwOy_4X__"